<template>
   <Link
      :href="route('events.view', { event: calendarEvent.slug })"
      class="group relative"
   >
      <div
         class="aspect-h-1 aspect-w-1 w-full h-full overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75"
      >
         <img
            loading="lazy"
            class="h-full w-full object-cover object-center absolute transform transition duration-500 group-hover:scale-105"
            :srcset="calendarEvent.thumbnail?.original_url"
            :alt="calendarEvent.title"
         >
      </div>
      <div
         class="h-full w-full left-0 top-0 absolute bg-neutral-950 bg-opacity-30 rounded-lg hover-animation"
      />
      <div class="absolute bottom-0 flex-col justify-start p-4">
         <div
            v-if="!isEmpty(calendarEvent.location_name)"
            class="flex items-center gap-x-1"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               fill="white"
               class="w-4 h-4"
            >
               <path
                  fill-rule="evenodd"
                  d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                  clip-rule="evenodd"
               />
            </svg>
            <div class="text-white text-base font-medium">
               {{ calendarEvent.location_name }}
            </div>
         </div>
         <div class="text-white text-xl font-extrabold uppercase">
            {{ calendarEvent.title }}
         </div>
         <span
            v-if="calendarEvent.fully_booked && !calendarEvent.in_past"
            class="inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700"
         >
            {{ $t('events.event_fully_booked') }}
         </span>
         <span
            v-if="calendarEvent.in_past"
            class="inline-flex items-center rounded-md bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800"
         >
            {{ $t('events.ended') }}
         </span>
      </div>

      <div
         class="top-0 right-0 absolute p-4"
         v-if="!isEmpty(calendarEvent.start_time)"
      >
         <div class="flex items-center space-x-2">
            <i class="pi pi-clock !text-white" />

            <p class="text-center text-white text-base font-bold uppercase">
               {{ calendarEvent.start_time }}
            </p>
         </div>
      </div>
      <div class="pt-4 top-0 left-0 absolute ml-2">
         <div class="flex items-center gap-x-1">
            <div class="flex items-center gap-x-1">
               <p class="text-center text-white text-base font-bold">
                  {{
                     eventStartDate
                  }}
               </p>
            </div>
         </div>
      </div>
   </Link>
</template>
<script setup>
   import { Link } from '@inertiajs/vue3';
   import { isEmpty } from 'lodash';
   import { computed } from 'vue';
   import { formatEventDate } from '@/composables/useFormatsDateTime.js';

   const props = defineProps({
      calendarEvent: Object,
   });

   const eventStartDate = computed(() => formatEventDate(props.calendarEvent.start_date, props.calendarEvent.end_date));

</script>
